import { render, staticRenderFns } from "./PropertyManager.vue?vue&type=template&id=d167f4fc&scoped=true"
import script from "./PropertyManager.vue?vue&type=script&lang=ts"
export * from "./PropertyManager.vue?vue&type=script&lang=ts"
import style0 from "./PropertyManager.vue?vue&type=style&index=0&id=d167f4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d167f4fc",
  null
  
)

export default component.exports